import React from 'react';

const FacebookLink = props =>
  <a
    rel="noopener"
    target="_blank"
    href="https://facebook.com/depop"
    {...props}>
    Facebook
  </a>;

export default FacebookLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/FacebookLink.js